<!-- 创建商家券模板并售卖商家券给商户接口内容 -->
<template>
  <div class="">
    <right-structure :Pdatas='infoData'>
      <pre slot="q_code">{{JSON.stringify(requestBody, null, 4)}}</pre>
      <pre slot="r_code">{{JSON.stringify(responseCode, null, 4)}}</pre>
    </right-structure>
  </div>
</template>

<script>
  import structure from "@/components/commonStructure"

  export default {
    name: '',
    components: {
      'right-structure': structure,
    },
    props: ['commonUrls'],
    data() {
      return {
        requestBody: {
          "traderCode": "2KNTYVWC",
          "parkCodeList": ["2KNTYVWC"],
          "totalCount": "1",
          "couponTemplate": {
            "name": "shidf",
            "validFrom": "20160906181930",
            "validTo": "20160906181930",
            "validMinute": "10",
            "balanceType": "0",
            "couponType": "1",
            "faceValue": "500",
            "originalPrice": "600",
            "realPrice": "500",
            "useRuleFrom": "0",
            "useRuleTo": "1000",
            "remark": "false",
            "couponRule": "0",
            "useParkingFee": "1",
            "financialParkCode": "2KNTYVWC"
          }
        },
        responseCode: {
          "data": {
            "couponCode": "2KNTYVWC",
            "sellBillId": "111",
            "createTime": "20170911000000"
          }, "message": "业务成功", "resultCode": 0, "status": 1
        },
        infoData: {
          explain: "第三方接入系统请求智慧停车开放平台创建指定电子优惠券并给指定商户售卖电子券",
          t_url: this.commonUrls.test + "createCouponTemplate",
          p_url: this.commonUrls.prod + "createCouponTemplate",
          precondition: "无",
          fitSystem: "VEMS传统停车场，云停车场",
          pattern: "智慧停车开放平台提供接口, 第三方接入系统主动请求",
          Q_params: [{
            titleName: null,
            tabledata: [{tableHead: '参数名', tdName: 'info1'}, {tableHead: '是否必填', tdName: 'info2'}, {
              tableHead: '类型',
              tdName: 'info3'
            }, {tableHead: '说明', tdName: 'info4'}],
            td: [
              {info1: 'name', info2: '是', info3: 'String', info4: '券名称, 相同'},
              {
                info1: 'sellFrom',
                info2: '是',
                info3: 'String',
                info4: '券可售卖的开始时间，yyyyMMddHHmmss。'
              },
              {
                info1: 'sellTo',
                info2: '是',
                info3: 'String',
                info4: '券可售卖的结束时间，yyyyMMddHHmmss。'
              },
              {
                info1: 'grantFrom',
                info2: '是',
                info3: 'String',
                info4: '券可发放的开始时间，yyyyMMddHHmmss。注意：该字段还约束具体券的最大有效起始时间'
              },
              {
                info1: 'grantTo',
                info2: '是',
                info3: 'String',
                info4: '券可发放的结束时间，yyyyMMddHHmmss。注意：该字段还约束具体券的最大有效结束时间，创建时请设定好该值，以避免车主用券时因券失效而无法用券'
              },
              {info1: 'validMinute', info2: '是', info3: 'Integer', info4: '发券后券的有效分钟数'},
              {info1: 'balanceType', info2: '是', info3: 'Integer', info4: '结算类型，0：销售结算 1：发放结算 2：使用结算'},
              {
                info1: 'couponType',
                info2: '是',
                info3: 'Integer',
                info4: '券类型，0：免费券，车费0元结算 1：金额扣减券，车费减免固定金额结算 2：金额折扣券，车费折扣减免结算 3：金额固定值券，车费按券的固定值结算 4：时间券，时间减免后再按车费结算 5:不同计价券,按不同计价规则车费结算'
              },
              {
                info1: 'faceValue',
                info2: '是',
                info3: 'String',
                info4: '面值，免费券:默认0，金额扣减券:为大于0的正数且保留2位小数，金额折扣券:为0-1且保留2位小数，金额固定券:为大于0的正数且保留2位小数，时间券:为大于0的整数，说明:金额相关的券都以元为单位，时间券以分为单位'
              },
              {info1: 'originalPrice', info2: '是', info3: 'Decimal', info4: '原价，不是出售的券填0.00'},
              {info1: 'realPrice', info2: '是', info3: 'Decimal', info4: '折扣价，不是出售的券填0.00'},
              {info1: 'useRuleFrom', info2: '是', info3: 'Decimal', info4: '可使用商家券，车费金额最小值'},
              {info1: 'useRuleTo', info2: '是', info3: 'Decimal', info4: '可使用商家券，车费金额最大值'},
              {info1: 'remark', info2: '否', info3: 'String', info4: '券备注'},
              {
                info1: 'couponRule',
                info2: '否',
                info3: 'int',
                info4: '0 扣减前面时间，1 扣减后面时间，2 扣减进场时间和优惠时间计算的金额，3 扣减优惠时间和计费结束时间计算的金额'
              },
              {info1: 'useParkingFee', info2: '否', info3: 'int', info4: '0 不使用免费时长，1 使用免费时长'},
              {info1: 'financialParkCode', info2: '否', info3: 'String', info4: '财务主体停车场编号；为空时默认取parkCodeList中的第一个'},
              {info1: 'isCover', info2: '否', info3: 'Integer', info4: '是否支持叠加，0：不支持，1：支持；默认0；当couponType=1或（couponType=4，couponRule=0）时生效'},
              {info1: 'maxCover', info2: '否', info3: 'Integer', info4: '最大叠加数量，当isCover生效并为1时生效'},
              {info1: 'limitless', info2: '否', info3: 'Integer', info4: '券数量是否无限，0：有限，1：无限'},
              {info1: 'totalCount', info2: '否', info3: 'Integer', info4: '创建券的数量, 最大值不能超过10万，当limitless生效并为0时生效'},
              {info1: 'maxCover', info2: '否', info3: 'Integer', info4: '最大叠加数量，当isCover生效并为1时生效'},
              {info1: 'maxCover', info2: '否', info3: 'Integer', info4: '最大叠加数量，当isCover生效并为1时生效'}
            ]
          }, {
            titleName: '扣减规则说明（当券类型为时间券时，couponType=4）',
            tabledata: [{tableHead: '扣减规则', tdName: 'info1'}, {
              tableHead: '优惠后有无免费时长',
              tdName: 'info2'
            }, {tableHead: '计费说明', tdName: 'info3'}, {tableHead: '入参说明', tdName: 'info4'}, {
              tableHead: '图解',
              tdName: 'image'
            }],
            td: [
              {
                info1: '扣减前面时间',
                info2: '有',
                info3: '默认；优惠后金额：将进场时间往后推时间券面值得到新计费起始时间，新计费起始时间和计费结束时间按计费规则计费得到优惠后金额；优惠金额：正常计费金额-优惠后金额',
                info4: 'couponRule:0, useParkingFee: 1',
                image: '/static/img/扣减前面时间按优惠后有免费时长.png'
              },
              {
                info1: '扣减前面时间',
                info2: '无',
                info3: '优惠后金额：将进场时间往后推时间券面值得到新计费起始时间，新计费起始时间和计费结束时间按去掉免费时长的计费规则计费得到优惠后金额；优惠金额：正常计费金额-优惠后金额',
                info4: 'couponRule:0, useParkingFee: 0',
                image: '/static/img/扣减前面时间.png'
              },
              {
                info1: '扣减后面时间',
                info2: '有',
                info3: '优惠后金额：将计费结束时间往前推时间券面值得到新计费结束时间，进场时间和新计费结束时间按计费规则计费得到优惠后金额；优惠金额：正常计费金额-优惠后金额',
                info4: 'couponRule:1, useParkingFee: 1',
                image: '/static/img/扣减后面时间有免费时长.png'
              },
              {
                info1: '扣减后面时间',
                info2: '无',
                info3: '优惠后金额：将计费结束时间往前推时间券面值得到新计费结束时间，进场时间和新计费结束时间按去掉免费时长的计费规则计费得到优惠后金额；优惠金额：正常计费金额-优惠后金额',
                info4: 'couponRule:1, useParkingFee: 0',
                image: '/static/img/扣减后面时间.png'
              },
              {
                info1: '扣减进场时间和优惠时间计算的金额',
                info2: '无',
                info3: '优惠金额：进场时间和计费结束时间（进场时间+优惠券面值）按计费规则计算得到优惠金额；优惠后金额：正常计费金额-优惠金额',
                info4: 'couponRule:2',
                image: '/static/img/扣减进场时间和优惠时间计算的金额.png'
              },
              {
                info1: '扣减优惠时间和计费结束时间计算的金额',
                info2: '无',
                info3: '优惠金额：计费起始时间（计费结束时间-优惠券面值）和计费结束时间按计费规则计算得到优惠金额；优惠后金额：正常计费金额-优惠金额',
                info4: 'couponRule:3',
                image: '/static/img/扣减优惠时间和结束时间计算的金额.png'
              }
            ]
          }],
          R_params: [{
            titleName: null,
            tabledata: [{tableHead: '参数名', tdName: 'info1'}, {tableHead: '是否必填', tdName: 'info2'}, {
              tableHead: '类型',
              tdName: 'info3'
            }, {tableHead: '说明', tdName: 'info4'}],
            td: [
              {info1: 'couponCode', info2: '是', info3: 'String', info4: '券模版代号'},
              {info1: 'sellBillId', info2: '是', info3: 'String', info4: '销售账单ID, 发券时需要用的重要参数'},
              {info1: 'createTime', info2: '是', info3: 'String', info4: '券创建时间，yyyyMMddHHmmss'}
            ]
          }],
          codeStatus: [{
            titleName: null,
            tabledata: [{tableHead: '状态码', tdName: 'info1'}, {tableHead: '说明', tdName: 'info2'}],
            td: [{info1: '000110', info2: '失败',}, {info1: '00110000', info2: '失败',}, {info1: '110000', info2: '失败',}]
          }],
        }
      }
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="less" scoped>
  // @import "../../assets/less/conmon.less";
</style>



// WEBPACK FOOTER //
// src/components/Doc/platform/preferential/coupon/createCouponTemplate.vue